module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"title":"Busca","home":"Home","search":"Resultado para","breadcrumb":"Resultados da busca"},"en":{"title":"Search","home":"Home","search":"Results for","breadcrumb":"Search results"},"es":{"title":"Busca","home":"Inicio","search":"Resultado por","breadcrumb":"Resultados de la búsqueda"}}')
  delete Component.options._Ctor
}
